import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Gallery, Item } from 'react-photoswipe-gallery';

const VideoSection = memo(
  ({ videoId, width = '100%', height = 168, construction, name, deadline }) => {
    const { t } = useTranslation();
    const [imagesSizesArr, setImagesSizesArr] = useState([]);
    const setBackgroundImg = url => ({
      backgroundImage: `url(${url})`
    });

    useEffect(() => {
      const resizeVideo = () => {
        if (!videoId) {
          return false;
        }
        const videoIframe = document.getElementById('video');
        const baseWidth = videoIframe.clientWidth;

        videoIframe.style.height = `${baseWidth / 1.775}px`;
      };

      resizeVideo();
      window.addEventListener('resize', resizeVideo);

      return () => {
        window.removeEventListener('resize', resizeVideo);
      };
    }, []);

    const galleryOptions = {
      showHideOpacity: true,
      history: true
    };

    useEffect(() => {
      const loadImage = image =>
        new Promise((resolve, reject) => {
          const loadImg = new Image();
          loadImg.src = image.full;
          loadImg.onload = () => resolve(image.url);
          loadImg.onerror = err => reject(err);
        });

      Promise.all(
        construction?.map(item => item.photos.map(image => loadImage(image)))
      )
        .then(() => {
          const getImages = document.getElementsByClassName(
            'apartment-photo-hidden'
          );
          const imagesData = [];

          Array.from(getImages).forEach(item => {
            imagesData.push({ width: item.width, height: item.height });
          });

          setImagesSizesArr(imagesData);
        })
        .catch(err => console.log('Failed to load images', err));
    }, []);

    const openPhotoModal = el => {
      document
        .getElementsByClassName(`video-section__i-thumbnail-img ${el}`)[0]
        .click();
    };

    return (
      <div className="video-section">
        <div className="video-section__title">{t('residences.promo')}</div>
        <div className="video-section__content">
          {videoId && (
            <div className="video-section__i">
              <iframe
                id="video"
                title={videoId}
                data-stat="residence-video"
                allowFullScreen=""
                frameBorder="0"
                width={width}
                height={height}
                src={`https://www.youtube.com/embed/${videoId}`}
              />
              <div className="video-section__i-title">{name}</div>
              <div className="video-section__i-description">{deadline}</div>
            </div>
          )}
          {construction &&
            construction?.map((item, index) => (
              <div className="video-section__i" key={index}>
                <div className="video-section__i-gallery">
                  {item?.youtubeVideoId && item?.isPromo && (
                    <iframe
                      id="video"
                      title={item.youtubeVideoId}
                      data-stat="residence-video"
                      allowFullScreen=""
                      frameBorder="0"
                      width={width}
                      height={height}
                      src={`https://www.youtube.com/embed/${item.youtubeVideoId}`}
                    />
                  )}
                  {item && !item.isPromo && (
                    <div
                      className="video-section__i-thumbnail"
                      onClick={() => {
                        openPhotoModal(index);
                      }}
                      onKeyPress={() => {
                        openPhotoModal(index);
                      }}
                      role="button"
                      tabIndex={0}
                    >
                      <img
                        src={item?.photos?.length && item?.photos[0].full}
                        className="video-section__i-thumbnail-img"
                        data-stat="residence-construction"
                        alt=""
                      />
                    </div>
                  )}
                </div>
                <div className="video-section__i-title">{item?.name}</div>
                <div className="video-section__i-description">{item?.date}</div>
              </div>
            ))}
        </div>
        {construction &&
          construction?.map((item, index) => (
            <div key={index}>
              {!item?.isPromo && (
                <div>
                  <Gallery options={galleryOptions}>
                    {item?.photos.map((photo, i) => (
                      <Item
                        original={photo.full}
                        thumbnail={photo.full}
                        key={i + index}
                        width={imagesSizesArr[i]?.width || 375}
                        height={imagesSizesArr[i]?.height || 250}
                      >
                        {({ ref, open }) => (
                          <div style={{ display: 'none' }}>
                            <div
                              ref={ref}
                              className={`video-section__i-thumbnail-img ${index}`}
                              onClick={open}
                              onKeyPress={open}
                              role="button"
                              tabIndex="-1"
                              style={setBackgroundImg(photo.full)}
                            />
                          </div>
                        )}
                      </Item>
                    ))}
                  </Gallery>
                </div>
              )}
            </div>
          ))}
      </div>
    );
  }
);

VideoSection.displayName = `ItemVideoSection`;

VideoSection.propTypes = {
  videoId: PropTypes.string,
  name: PropTypes.string,
  deadline: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  construction: PropTypes.array
};

export default VideoSection;
